import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import vuetify from './plugins/vuetify';
import store from './store';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { createAuth0 } from '@auth0/auth0-vue'; 
import 'leaflet/dist/leaflet.css';
import VueGtag from "vue-gtag";
import * as Sentry from "@sentry/vue";

const app = createApp(App);

// Initialize Google Analytics (vue-gtag)
app.use(VueGtag, {
  config: { id: "G-TD5KM99DEG" }, // Google Analytics Measurement ID
  appName: "C-State",
  pageTrackerScreenviewEnabled: true, // Enables page tracking
}, router); 


app.use(
  createAuth0({
    domain: process.env.VUE_APP_AUTH0_DOMAIN,
    clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: process.env.VUE_APP_AUTH0_AUDIENCE,
      scope: 'openid profile email read:all offline_access'
    },
    useRefreshTokens: true,
    cacheLocation: 'localstorage',
  })
);

Sentry.init({
  app,
  dsn: "https://fdcc9b67dbe0d53a25aa556114f5b0dd@o4508813992198144.ingest.us.sentry.io/4508882085937152",
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const originalConsoleError = console.error;
console.error = (...args) => {
  if (
    args[0] instanceof Error && 
    args[0].message.includes('ResizeObserver')
  ) {
    return;
  }
  originalConsoleError.apply(console, args);
};

app.use(router);
app.use(vuetify);
app.use(store);
app.use(VueAxios, axios);

app.mount('#app');